// extracted by mini-css-extract-plugin
export default {"wrapper":"Statistic_wrapper__kHtpz","title":"Statistic_title__fivJJ","data":"Statistic_data__gaYaV"};